export const STATUSES = {
    COMPLETE: 'complete',
    ERROR: 'error',
    ERROR_LOADING: 'error_loading',
    ERROR_SAVING: 'error_saving',
    ERROR_SENDING: 'error_sending',
    ERROR_SENDING_NO_RECIPIENTS: 'error_sending_no_recipients',
    ERROR_HAS_NOT_FINISHED_EDITING: 'error_has_not_finished_editing',
    LOADING: 'loading',
    NEW: 'new',
    READY: 'ready',
    SAVING: 'saving',
    SENDING: 'sending',
    SUCCESS: 'success',
};

export const STATUS_ICONS = {
    active: 'active',
    complete: 'complete',
    error: 'error',
};

export const STEPS = {
    AUDIENCE: 'AUDIENCE',
    CONTENT: 'CONTENT',
    SCHEDULE: 'SCHEDULE',
    SENDER: 'SENDER',
    SUBJECT: 'SUBJECT',
};

export const STEP_ERRORS = {
    ERROR_FETCHING_USERS: 'ERROR_FETCHING_USERS',
    ERROR_FETCHING_CUSTOM_DOMAINS: 'ERROR_FETCHING_CUSTOM_DOMAINS',
    ERROR_FETCHING_LOCALIZATION_INFO: 'ERROR_FETCHING_LOCALIZATION_INFO',

    SENDER_NOT_FOUND: 'SENDER_NOT_FOUND',
    SENDER_DKIM_ERROR: 'SENDER_DKIM_ERROR',

    NO_ELIGIBLE_RECIPIENTS: 'NO_ELIGIBLE_RECIPIENTS',

    SUBJECT_OR_PREVIEW_LIMIT_EXCEEDED: 'SUBJECT_OR_PREVIEW_LIMIT_EXCEEDED',
};
